import { render, staticRenderFns } from "./Coin_Reward.vue?vue&type=template&id=a36d00fa&scoped=true"
import script from "./Coin_Reward.vue?vue&type=script&lang=js"
export * from "./Coin_Reward.vue?vue&type=script&lang=js"
import style0 from "./Coin_Reward.vue?vue&type=style&index=0&id=a36d00fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d00fa",
  null
  
)

export default component.exports